import { useEffect } from 'react'
import { isIOS } from 'react-device-detect'
import { useDispatch, useSelector } from 'react-redux'
import { setUserInteracted } from 'redux/actions/playerControlActions'
import { setHideControls } from 'redux/actions/playerControlActions'
import PlayerControls from './PlayerControls'

let timeoutId
export default function VideoPlayerControls({ mute, unmute, play, pause,
    rewind, forward, mediaRef, controlRef }) {
    const { hideControls, userMutedMedia, userInteracted, videoPlaying } = useSelector(state => state.playerControls)

    const { playListIndex, showAi } = useSelector(state => state.harmonize)

    const dispatch = useDispatch()


    const controls = () => {
        if (!hideControls) {
            return <PlayerControls
                mute={mute}
                unmute={unmute}
                play={play}
                pause={pause}
                rewind={rewind}
                forward={forward}
                mediaRef={mediaRef}
                controlRef={controlRef}
            />

        }
    }

    useEffect(() => {
        console.log(`VideoPlayerControls useEffect playListIndex ${playListIndex} 
         isIOS ${isIOS} videoPlaying ${videoPlaying} 
         hideControls ${hideControls}
         userInteracted ${userInteracted}
         userMutedMedia ${userMutedMedia} timeoutId ${timeoutId}`)
        if (showAi) {
            dispatch(setHideControls(false))
        } else if (!videoPlaying && timeoutId) {
            console.log('VideoPlayerControls clearTimeout because videoPlaying is false')
            clearTimeout(timeoutId)
            timeoutId = null
        } else if (userInteracted && videoPlaying && !timeoutId) {
            console.log(`VideoPlayerControls useEffect setTimeout`)
            dispatch(setHideControls(false))
            timeoutId = setTimeout(() => {
                console.log('VideoPlayerControls...execute timeout hideControls')
                dispatch(setHideControls(true))
            }, 5000)
        }
        return () => {
            console.log('VideoPlayerControls returns clearTimeout')
            clearTimeout(timeoutId)
            timeoutId = null
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playListIndex, videoPlaying])

    return controls()
}